import { CaretUpDownIcon } from '@phosphor-icons/react';
import { ColumnDef } from '@tanstack/react-table';
import { format } from 'date-fns/format';

import { Button } from '@/components/ui/button';
import { GenericTable, TableItemStatus } from '@/modules/common/components';

import { Model } from '../types';

interface ModelsTableProps {
  data: Model[];
  onClick: (item: Model) => void;
}

const columns: ColumnDef<Model>[] = [
  {
    accessorKey: 'name',
    header: 'Model Name',
  },
  {
    accessorKey: 'type',
    header: 'Model Type',
    cell: ({ row }) => row.original.type.value,
  },
  {
    accessorKey: 'color',
    header: 'Color',
    cell: ({ row }) => row.original.color.value,
  },
  {
    accessorKey: 'gender',
    header: 'Gender',
    cell: ({ row }) => row.original.gender.value,
  },
  {
    accessorKey: 'status',
    header: 'Status',
    size: 200,
    cell: ({ row }) => <TableItemStatus status={row.getValue('status')} />,
  },
  {
    size: 130,
    accessorKey: 'updatedAt',
    header: ({ column }) => {
      return (
        <Button
          variant="transparent"
          className="p-0 uppercase text-sm font-bold"
          onClick={() => column.toggleSorting(column.getIsSorted() === 'asc')}
        >
          Upload Date
          <CaretUpDownIcon />
        </Button>
      );
    },
    cell: ({ row }) =>
      format(new Date(row.getValue('updatedAt')), 'yyyy-MM-dd'),
  },
];

export function ModelsTable({ data, onClick }: ModelsTableProps) {
  return (
    <GenericTable
      data={data}
      onClick={onClick}
      columns={columns}
      searchable
      searchColumns={['name']}
      searchPlaceholder="Search by model name"
      emptyDescription="No models uploaded yet"
    />
  );
}
